import React, { useState, useEffect, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import {
  forgotRemoveData,
  updatePassword,
} from "reduxStore/action/authActions";
import { seo } from "utils/utils";

const Resetpassword = () => {
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);
  const [passShown, setPassShown] = useState(false);
  const [formInput, setFormInput] = useState({
    password: "",
    confirmPassword: "",
  });

  const [formError, setFormError] = useState({
    password: "",
    confirmPassword: "",
  });

  const dispatch = useDispatch();

  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};

  const updatePasswordData = async () => {
    const { response, reset = false } = forgotPasswordSelector || {};
    if (response && reset) {
      if (response?.status === 200) {
        dispatch(forgotRemoveData());
        navigate("/login");
      }
    }
  };

  const handleUserInput = (name, value) => {
    setFormInput({
      ...formInput,
      [name]: value,
      email: forgotPasswordSelector.data.email,
    });
  };

  const handleEnterPressFromFirst = (event) => {
    // console.log('User pressed: ', event.key);

    // console.log(message);

    if (event.key === "Enter") {
      const next = document.getElementById("focus_2");
      next.focus();
      // 👇️ your logic here
      // console.log('Enter key pressed ✅');
    }
  };
  const handleEnterPressFromSecond = (event) => {
    // console.log('User pressed: ', event.key);

    // console.log(message);

    if (event.key === "Enter") {
      // 👇️ your logic here
      event.preventDefault();
      // console.log('Enter key pressed ✅');
      Resetpassword();
    }
  };

  useEffect(() => {
    updatePasswordData();
  }, [forgotPasswordSelector]);

  const validateFormInput = () => {
    let inputError = {
      password: "",
      confirmPassword: "",
    };
    let isError = true;

    if (!formInput.password) {
      setFormError({
        ...inputError,
        isError: false,
        password: strings.emptypassword,
      });
      return;
    }

    if (formInput.confirmPassword !== formInput.password) {
      setFormError({
        ...inputError,
        isError: false,
        confirmPassword: strings.confirmPasswordError,
      });
      return;
    }

    if (!formInput.password) {
      setFormError({
        ...inputError,
        isError: false,
        password: strings.passwordError,
      });
      return;
    }

    setFormError(inputError);
    return isError;
  };

  const Resetpassword = () => {
    if (validateFormInput()) {
      dispatch(updatePassword(formInput));
    }
  };
  useEffect(() => {
    seo({
      title: "Change Password",
      metaDescription: "Followup listing",
      canonicalLink: window.location.href,
    });
  }, []);
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };
  const togglePass = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPassShown(!passShown);
  };
  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* login page start*/}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img
                        className="login-logo"
                        src="/assets/images/JUSTOLOGO.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>{strings.changepass}</h4>
                          <h6>{strings.enterNewPass}</h6>
                        </div>
                        <form className="theme-form">
                          <div>
                            <label className="col-form-label pt-2">
                              {strings.newPass}
                            </label>
                          </div>
                          <div className="input-group">
                            <input
                              className="form-control"
                              id="focus_2"
                              type={passwordShown ? "text" : "password"}
                              value={formInput.password}
                              name="password"
                              placeholder={strings.newPass}
                              required=""
                              onChange={({ target }) => {
                                handleUserInput(target.name, target.value);
                              }}
                              onKeyDown={handleEnterPressFromSecond}
                              style={{
                                backgroundColor: "#e8f0fe",
                                borderRight: "none",
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                style={{
                                  backgroundColor: "#e8f0fe",
                                  borderLeft: "none",
                                }}
                              >
                                <i
                                  style={{
                                    left: "370px",
                                    fontSize: "20px",
                                    top: "6px",
                                  }}
                                  className={
                                    passwordShown
                                      ? "fa fa-eye"
                                      : "fa fa-eye-slash"
                                  }
                                  onClick={togglePassword}
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                          {formError.password && (
                            <span style={{ color: "red" }}>
                              {formError.password}
                            </span>
                          )}
                          <div>
                            <label className="col-form-label pt-2">
                              {strings.confirmPass}
                            </label>
                          </div>
                          <div className="input-group">
                            <input
                              className="form-control"
                              id="focus_2"
                              type={passShown ? "text" : "password"}
                              value={formInput.confirmPassword}
                              name="confirmPassword"
                              placeholder="Confirm Password"
                              required=""
                              onChange={({ target }) => {
                                handleUserInput(target.name, target.value);
                              }}
                              onKeyDown={handleEnterPressFromSecond}
                              style={{
                                backgroundColor: "#e8f0fe",
                                borderRight: "none",
                              }}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                style={{
                                  backgroundColor: "#e8f0fe",
                                  borderLeft: "none",
                                }}
                              >
                                <i
                                  style={{
                                    left: "370px",
                                    fontSize: "20px",
                                    top: "6px",
                                  }}
                                  className={
                                    passShown ? "fa fa-eye" : "fa fa-eye-slash"
                                  }
                                  onClick={togglePass}
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </div>
                          </div>
                          {formError.confirmPassword && (
                            <span style={{ color: "red" }}>
                              {formError.confirmPassword}
                            </span>
                          )}
                          <div className="form-group form-row mt-4 mb-0">
                            <button
                              onClick={() => Resetpassword()}
                              className="btn btn-primary btn-block"
                              type="button"
                            >
                              {strings.changepassword}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* login page end*/}
        </div>
      </div>
    </Fragment>
  );
};

export default Resetpassword;
